import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";

const Soho = ({ onChange, propertyDataBackend }) => {
  const [propertyData, setPropertyData] = useState({
    total_quantity: "",
    no_of_bathroom: "",
    no_of_kitchen: "",
    no_of_bedroom: "",
  });

  useEffect(() => {
    if (propertyDataBackend) {
      setPropertyData({
        total_quantity: propertyDataBackend.total_quantity || "",
        no_of_bathroom: propertyDataBackend.no_of_bathroom || "",
        no_of_kitchen: propertyDataBackend.no_of_kitchen || "",
        no_of_bedroom: propertyDataBackend.no_of_bedroom || "",
      });
    }
  }, [propertyDataBackend]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...propertyData, [name]: value };
    setPropertyData(updatedState);
    if (onChange) {
      onChange(updatedState);
    }
  };

  return (
    <div className="grid-span-2">
      <div className="grid-template-2 gap-10">
        <TextInput
          label="No. of Units"
          min={0}
          required
          type="number"
          value={propertyData.total_quantity || "N/A"}
          name="total_quantity"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Bathroom(s)"
          min={0}
          required
          value={propertyData.no_of_bathroom || "N/A"}
          type="number"
          name="no_of_bathroom"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Kitchen(s)"
          min={0}
          required
          value={propertyData.no_of_kitchen || "N/A"}
          type="number"
          name="no_of_kitchen"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Bedroom(s)"
          min={0}
          required
          value={propertyData.no_of_bedroom || "N/A"}
          type="number"
          name="no_of_bedroom"
          onChange={handleAddChange}
        ></TextInput>
      </div>
    </div>
  );
};

export default Soho;
